import React from 'react';
import { formatCurrency } from '../../utils/formatCurrency';

export interface DiscountStackProps {
  original: number;
  net: number;
  percentage?: number | null;
  amount?: number | null;
  strong?: boolean;
}

/** ONE consistent discount presentation used everywhere (line labor, line parts
 *  combined, and each part): original (strikethrough) → −$amount (−pct%) → net.
 *  When there's no discount it shows just the net price. Lifted from the estimate
 *  editor's `discountStack` helper (ServiceItemsTable.tsx) so estimate + WO match. */
const DiscountStack: React.FC<DiscountStackProps> = ({ original, net, percentage, amount, strong }) => {
  const computed = original - net;
  const discountAmount = amount != null ? amount : computed;
  const has = discountAmount > 0.005;
  const pct = percentage != null ? percentage : (original > 0 ? (discountAmount / original) * 100 : 0);
  return (
    <div style={{ textAlign: 'right', lineHeight: 1.35 }}>
      {has && (
        <div style={{ fontSize: 11, textDecoration: 'line-through', color: '#9ca3af' }}>{formatCurrency(original)}</div>
      )}
      {has && (
        <div style={{ fontSize: 11, color: '#ef4444' }}>-{formatCurrency(discountAmount)} (-{pct.toFixed(0)}%)</div>
      )}
      <div style={{ fontSize: strong ? 15 : 13, fontWeight: strong ? 700 : 600, color: '#10b981' }}>{formatCurrency(net)}</div>
    </div>
  );
};

export default DiscountStack;
